import logoSrc from '../../assets/images/ai_logo.svg';
import gonganIcon from '../../img/logo01.png';
import codeImg from '../../img/code.png';
import { JOIN_US } from '../../config/data';
import { Icon } from '../Icons';
import { usePage, PAGES } from '../../context/PageContext';
import { t } from '../../utils/i18n';
import './index.css';

/* 2-3 列短链接 —— 向截图 IQuestLab Footer 那种"克制学术"靠拢 */
const FOOTER_GROUPS = [
    {
        title: 'EXPLORE',
        links: [
            { name: t('研究方向', 'Research'), to: PAGES.RESEARCH },
            { name: t('大模型', 'Large Models'), to: PAGES.RESEARCH_LLM },
            { name: t('医疗智能', 'Medical AI'), to: PAGES.RESEARCH_MEDICAL },
            { name: t('生命科学', 'Life Sciences'), to: PAGES.RESEARCH_LIFE },
            { name: t('数学智能', 'Mathematical AI'), to: PAGES.RESEARCH_MATH },
            { name: t('数智电力', 'Power Intelligence'), to: PAGES.RESEARCH_POWER },
        ],
    },
    {
        title: 'CONNECT',
        links: [
            { name: t('关于我们', 'About Us'), to: PAGES.TEAM },
            { name: t('动态', 'Updates'), to: PAGES.UPDATES },
            { name: t('加入我们', 'Join Us'), href: JOIN_US.href, target: '_blank' },
            { name: t('联系我们', 'Contact Us'), to: PAGES.TEAM, anchor: 'contact' },
            { name: t('官方网站', 'Website'), href: 'https://iquestlab.github.io/', target: '_blank' },
            { name: 'GitHub', href: 'https://github.com/IQuestLab', target: '_blank' },
            { name: 'X / Twitter', href: 'https://x.com/iquestlab', target: '_blank' },
        ],
    },
    {
        title: 'LEGAL',
        links: [
            { name: t('隐私政策', 'Privacy Policy'), href: `${process.env.PUBLIC_URL || ''}/docs/privacy-statement.pdf`, target: '_blank' },
            { name: t('使用条款', 'Terms of Use'), href: `${process.env.PUBLIC_URL || ''}/docs/terms-of-use.pdf`, target: '_blank' },
        ],
    },
];

const SOCIAL_LINKS = [
    {
        label: 'X / Twitter',
        href: 'https://x.com/iquestlab',
        iconName: 'twitter',
        target: '_blank',
    },
    {
        label: 'GitHub',
        href: 'https://github.com/IQuestLab',
        iconName: 'github',
        target: '_blank',
    },
    {
        label: 'Email',
        href: 'mailto:hr@iquestlab.com',
        iconName: 'mail',
    },
];

export default function Footer() {
    const { navigate } = usePage();
    const site = process.env.REACT_APP_SITE || 'iquestlab';
    console.log('[Footer] rendered – 公安备案 version deployed');
    return (
        <footer className="site-footer">
            <div className="site-footer-inner">
                <div className="site-footer-grid">
                    <div className="site-footer-brand">
                        <button
                            type="button"
                            className="site-footer-logo"
                            aria-label={t('至知创新研究院', 'IQuest Research')}
                            onClick={() => navigate(PAGES.HOME)}
                        >
                            <span className="site-footer-logo-dot" aria-hidden />
                            <img src={logoSrc} alt="至知" />
                        </button>
                        <p className="site-footer-tagline">
                            {t('以原创算法与下一代 AI 架构，攻坚科研与产业。', 'AI delivers more.')}
                        </p>
                        <div className="site-footer-social" aria-label="社交账号">
                            {SOCIAL_LINKS.map((s) => (
                                <a
                                    key={s.label}
                                    href={s.href}
                                    target={s.target}
                                    rel={s.target === '_blank' ? 'noreferrer' : undefined}
                                    className="site-footer-social-link"
                                    aria-label={s.label}
                                    title={s.label}
                                >
                                    <Icon name={s.iconName} width={16} height={16} />
                                </a>
                            ))}
                        </div>
                    </div>
                    {FOOTER_GROUPS.map((group) => (
                        <div key={group.title} className="site-footer-col">
                            <div className="site-footer-col-title">{group.title}</div>
                            <ul>
                                {group.links.map((link) => (
                                    <li key={link.name}>
                                        {link.to ? (
                                            <button
                                                type="button"
                                                className="site-footer-navbtn"
                                                onClick={() => {
                                                    navigate(link.to);
                                                    if (link.anchor) {
                                                        setTimeout(() => {
                                                            const el = document.getElementById(link.anchor);
                                                            if (el) el.scrollIntoView({ behavior: 'smooth' });
                                                        }, 100);
                                                    }
                                                }}
                                            >
                                                {link.name}
                                            </button>
                                        ) : (
                                            <a href={link.href} target={link.target} rel="noreferrer">
                                                {link.name}
                                            </a>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                    <div className="site-footer-qrcode">
                        <img src={codeImg} alt="IQuest 公众号" className="site-footer-qrcode-img" />
                        <span className="site-footer-qrcode-label">{t('IQuest 公众号', 'IQuest Official Account')}</span>
                    </div>
                </div>
                <div className="site-footer-bottom">
                    <div className="site-footer-bottom-left">
                        <span>{t('© 2026 北京至知科技有限公司', '© 2026 IQuest Research')}</span>
                        {site === 'iquestlab' && (
                            <>
                                <a
                                    href="https://beian.miit.gov.cn/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="site-footer-icp"
                                >
                                    京ICP备2026001824号-1
                                </a>
                                <a
                                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802048716"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="site-footer-icp"
                                >
                                    <img src={gonganIcon} alt="" className="site-footer-gongan-icon" />
                                    京公网安备11010802048716号
                                </a>
                            </>
                        )}
                        {site === 'iquest' && (
                            <>
                                <a
                                    href="https://beian.miit.gov.cn/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="site-footer-icp"
                                >
                                    京ICP备2026001824号-2
                                </a>
                                <a
                                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802049381"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="site-footer-icp"
                                >
                                    <img src={gonganIcon} alt="" className="site-footer-gongan-icon" />
                                    京公网安备11010802049381号
                                </a>
                            </>
                        )}
                    </div>
                    <span className="site-footer-credit">
                        Built with <span className="site-footer-credit-accent">insight</span> · Made in Beijing
                    </span>
                </div>
            </div>
        </footer>
    );
}
